import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroSection = ({ onNavigate }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary-50 via-white to-secondary-50 pt-24 pb-16 lg:pt-32 lg:pb-24 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-32 h-32 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-secondary rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center space-x-2 bg-primary-100 text-primary-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <Icon name="Heart" size={16} />
              <span>Where Technology Meets Human Connection</span>
            </div>
            
            <h1 className="font-heading text-4xl lg:text-6xl font-bold text-accent-800 mb-6 leading-tight">
              Transforming Gift-Giving Into
              <span className="text-gradient-primary block mt-2">
                Meaningful Moments
              </span>
            </h1>
            
            <p className="text-lg lg:text-xl text-accent-600 mb-8 leading-relaxed max-w-2xl">
              At Giftsy Modern, we believe the best gifts aren't just products—they're expressions of understanding, care, and relationship depth. We're here to transform gift anxiety into gift confidence.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                variant="primary"
                size="lg"
                iconName="Sparkles"
                iconPosition="left"
                onClick={() => onNavigate('/gift-finder')}
                className="shadow-warm hover:shadow-primary"
              >
                Start Finding Gifts
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Users"
                iconPosition="left"
                onClick={() => onNavigate('/community')}
              >
                Join Our Community
              </Button>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <Image
                src="https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=600&h=400&fit=crop"
                alt="Happy family exchanging gifts during celebration"
                className="w-full h-96 lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg p-4 border border-accent-100">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-success-100 rounded-lg flex items-center justify-center">
                  <Icon name="Gift" size={24} className="text-success-600" />
                </div>
                <div>
                  <p className="font-bold text-accent-800">50K+</p>
                  <p className="text-sm text-accent-600">Perfect Matches</p>
                </div>
              </div>
            </div>
            
            <div className="absolute -top-6 -right-6 bg-white rounded-xl shadow-lg p-4 border border-accent-100">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
                  <Icon name="Heart" size={24} className="text-primary-600" />
                </div>
                <div>
                  <p className="font-bold text-accent-800">98%</p>
                  <p className="text-sm text-accent-600">Happy Recipients</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;